__turbopack_context__.v({
  "footer-container": "default-footer-module-scss-module__iqT14W__footer-container",
  "footer-section": "default-footer-module-scss-module__iqT14W__footer-section",
  "notice": "default-footer-module-scss-module__iqT14W__notice",
  "partner-logo": "default-footer-module-scss-module__iqT14W__partner-logo",
});
